import { getJSON } from "oj-ajax"
import { ICoords, IStore } from "./utils"
import { getBaseUrl } from "../../utils";

export enum Culture {
  nlNl = "nl-nl",
  nlBe = "nl-be",
  frBe = "fr-be",
  frFr = "fr-fr",
}
export const getCulture = (): Culture => (window["culture"] || "nl-nl").toLowerCase()

export const findStoresByCoords = async ({ lat, lng }: ICoords, eid?: string) => {
  const deliveryDays = window["deliveryDays"];
  let apiUrl = `${getBaseUrl()}/api/photoprintsstores/?latitude=${lat}&longitude=${lng}&eid=${eid ?? ""}`

  if (deliveryDays)
    apiUrl = `${getBaseUrl()}/api/stores/?latitude=${lat}&longitude=${lng}${deliveryDays.toString().length > 0 ? `&deliveryDays=${deliveryDays}` : ''}`

  try {
    const res = await fetch(apiUrl, {
      method: "GET",
      headers: { "Content-Type": "application/json", "Accept-Language": window["culture"] },
    })
    const { stores }: any = await res.json()

    stores.forEach(s =>
      s.days
        .filter(d => d && d.openingTime && !d.closingTime)
        .forEach(d => d.closingTime = { hour: 23, minute: 59 }))

    return stores
  }
  catch (err) {

  }
}

export const updateStore = async (locationId: string) => {
  try {
    const res = await fetch(`${getBaseUrl()}/Checkout/UpdateStore`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': window["culture"],
        'RequestVerificationToken': window["requestVerificationToken"]
      },
      body: JSON.stringify({ locationId })
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    await res.json().then(res => {
      location.href = res.redirectUrl
    });
  } catch (err) {
    console.error('Error updating store:', err);
    throw err;
  }

}




// export const findStoresByCoords = async ({ lat, lng }: ICoords) => {
//   const deliveryDays = window["deliveryDays"];
//   const { stores } = await getJSON(`/api/stores/?latitude=${lat}&longitude=${lng}${deliveryDays.toString().length > 0 ? `&deliveryDays=${deliveryDays}` : ''}`) as { stores: IStore[] }
//   // stores.forEach(s =>
//   // s.days
//   //   .filter(d => d && d.openingTime && !d.closingTime)
//   //   .forEach(d => d.closingTime = { hour: 23, minute: 59 }))
//   return stores
// }